import MDSpinner from "react-md-spinner";
import React from "react";

const LoadingView = ({ isBusy , message , children }) => {

    return isBusy ? <div className="p-5 text-center">
        <MDSpinner size={32}/>
        <p>{message}</p>
    </div> : <React.Fragment>{children}</React.Fragment>;
};


export default LoadingView;


// WEBPACK FOOTER //
// ./src/components/Elements/LoadingView.js